module.exports = __webpack_public_path__ + "static/media/Lightning.3bf90e76.svg";